var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4771_10360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 10.6666C8.66683 11.0348 8.36835 11.3333 8.00016 11.3333C7.63197 11.3333 7.3335 11.0348 7.3335 10.6666C7.3335 10.2984 7.63197 9.99992 8.00016 9.99992C8.36835 9.99992 8.66683 10.2984 8.66683 10.6666Z",
    fill: "#FF675C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 4.66659C8.50016 4.39044 8.27631 4.16659 8.00016 4.16659C7.72402 4.16659 7.50016 4.39044 7.50016 4.66659V8.66659C7.50016 8.94273 7.72402 9.16659 8.00016 9.16659C8.27631 9.16659 8.50016 8.94273 8.50016 8.66659V4.66659Z",
    fill: "#FF675C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833252C4.04212 0.833252 0.833496 4.04188 0.833496 7.99992C0.833496 11.958 4.04212 15.1666 8.00016 15.1666C11.9582 15.1666 15.1668 11.958 15.1668 7.99992C15.1668 4.04188 11.9582 0.833252 8.00016 0.833252ZM1.8335 7.99992C1.8335 4.59416 4.59441 1.83325 8.00016 1.83325C11.4059 1.83325 14.1668 4.59416 14.1668 7.99992C14.1668 11.4057 11.4059 14.1666 8.00016 14.1666C4.59441 14.1666 1.8335 11.4057 1.8335 7.99992Z",
    fill: "#FF675C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4771_10360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/Missing.9ba924ce329841ffefaabf58306f6b6b.svg";
export { ForwardRef as ReactComponent };